<!-- <div class="container-fluid mt-md-3">
  <h1><i class="fa fa-users text-danger mr-1"></i> Users Data</h1>
  <hr>
  <div class="row">
    <div class="col-md-9">

      <div>
        <mat-spinner *ngIf="fetchingData"></mat-spinner>
      </div>

      <div class="mb-5" *ngIf="users.length>0 && !fetchingData" style="max-height:90vh;overflow-y:auto;">


        <div class="col-sm-12">
          <mat-form-field class="col-lg-7">
            <mat-label>Filter</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="Filter value">
          </mat-form-field>
          <button class="example-button-row col-lg-2 m-1" mat-raised-button
            style="background-color: #3f51b5;color: white;"
          (click)="this.getData()">Refetch data</button>
            <button class="example-button-row col-lg-2 m-1" mat-raised-button
            style="background-color: #3f51b5;color: white;" [routerLink]="['new']">Insert user</button>
        </div>


        <table mat-table [dataSource]="tableData" class="mat-elevation-z8 col-sm-12">

          <ng-container matColumnDef="userId">
            <th mat-header-cell *matHeaderCellDef class="px-2"> ID </th>
            <td mat-cell *matCellDef="let element;index as i"  class="px-2"> {{i+1}} </td>
          </ng-container>

          <ng-container matColumnDef="user_upn">
            <th   mat-header-cell *matHeaderCellDef> User UPN </th>
            <td  mat-cell *matCellDef="let element"> {{element.user_upn}} </td>
          </ng-container>

          <ng-container matColumnDef="user_email">
            <th   mat-header-cell *matHeaderCellDef> Email Address </th>
            <td  mat-cell *matCellDef="let element" class="text-center"> {{element.user_email}} </td>
          </ng-container>

          <ng-container matColumnDef="createdAt"  >
            <th mat-header-cell *matHeaderCellDef > Created Date </th>
            <td mat-cell *matCellDef="let element" class="text-center"> {{element.createdAt}} </td>
          </ng-container>

          <ng-container matColumnDef="updatedAt">
            <th mat-header-cell *matHeaderCellDef> Updated Date </th>
            <td mat-cell *matCellDef="let element"> {{element.updatedAt?element.updatedAt:'No updates were made'}} </td>
          </ng-container>

          <ng-container matColumnDef="createdBy">
            <th mat-header-cell *matHeaderCellDef> Created By </th>
            <td mat-cell *matCellDef="let element"> {{element.createdBy?element.createdBy:'NA'}} </td>
          </ng-container>

          <ng-container matColumnDef="lastUpdatedBy">
            <th mat-header-cell *matHeaderCellDef> Updated By </th>
            <td mat-cell *matCellDef="let element"> {{element.lastUpdatedBy?element.lastUpdatedBy:'NA'}} </td>
          </ng-container>

          <ng-container matColumnDef="user_role">
            <th mat-header-cell *matHeaderCellDef> Role </th>
            <td mat-cell *matCellDef="let element" class="text-center"> {{element.user_role}} </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> <i class="fa fa-cogs fa-2x" ></i></th>
            <td mat-cell *matCellDef="let element">
              <div >
                <button mat-raised-button  color="primary"  class="dropdown-toggle m-1"
                 type="button" id="dropdownMenuButton" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false">
                  Actions
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <button mat-stroked-button color="primary" class="dropdown-item"
                   (click)="sendUserToChildComponent_update(element)">
                   Update
                  </button>
                  <button mat-stroked-button [color]="element.is_active? 'warn' : 'primary' "
                   class="dropdown-item"
                  (click)="sendUserToChildComponent_activateOrDeactivateUser(element)">
                   {{element.is_active?"Deactivate User":"Activate User"}}
                  </button>
                  <button mat-stroked-button color="warn"
                  class="dropdown-item" (click)="openDialog(element.id)">Delete</button>
                </div>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>


      </div>

      <div *ngIf="users.length==0 && !fetchingData">
        <p>No data available</p>
        <div class="example-button-row">
          <button class="m-1" mat-raised-button style="background-color: blue;color: white;"
          (click)="this.getData()">Refetch data</button>
          <button class="m-1" mat-raised-button style="background-color: green;color: white;"
          [routerLink]="['new']">Insert new user</button>
        </div>
      </div>

    </div>
    <div class="col-md-3" *ngIf="!fetchingData">
      <h2 class="text-capitalize font-weight-bold "><i class="fa fa-address-card text-danger mr-1"></i>Choose<span class="text-lowercase"> a user to update or insert new user</span></h2>
      <router-outlet></router-outlet>
    </div>
  </div>
</div> -->








<!-- this is the old code -->




<!-- <div class="row m-4">
  <div class="col-md-3">
    <app-navbar></app-navbar>
  </div>
  <div class="col-md-4">
    <h1 class="center">
      <i class="fa fa-server"
        style="margin-right: 6px;color: rgb(202,1,1);font-size: 28px;"></i>Administrator
    </h1>
  </div>
</div> -->

<div class="container-fluid mt-md-3">
  <h1><i class="fa fa-users text-danger mr-1"></i> Users Data</h1>
  <hr>
  <div class="row">
    <div class="col-md-8">
      <div>
        <mat-spinner *ngIf="fetchingData"></mat-spinner>
      </div>
      <div class="mb-5" *ngIf="users.length>0 && !fetchingData" style="max-height:90vh;overflow-y:auto;">


        <div class="col-sm-12">
          <mat-form-field class="col-lg-7">
            <mat-label>Filter</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="Filter value">
          </mat-form-field>
          <button class="example-button-row col-lg-2 m-1" mat-raised-button
            style="background-color: #3f51b5;color: white;"
          (click)="this.getData()">Refetch data</button>
            <button class="example-button-row col-lg-2 m-1" mat-raised-button
            style="background-color: #3f51b5;color: white;" [routerLink]="['new']">Insert user</button>
        </div>


        <table mat-table [dataSource]="tableData" class="mat-elevation-z8 col-sm-12">

          <ng-container matColumnDef="userId">
            <th mat-header-cell *matHeaderCellDef class="px-2"> ID </th>
            <td mat-cell *matCellDef="let element;index as i"  class="px-2"> {{i+1}} </td>
          </ng-container>

          <!-- <ng-container matColumnDef="username">
            <th   mat-header-cell *matHeaderCellDef> Username </th>
            <td  mat-cell *matCellDef="let element"> {{element.user_email}} </td>
          </ng-container> -->

          <ng-container matColumnDef="upn">
            <th   mat-header-cell *matHeaderCellDef> UPN </th>
            <td  mat-cell *matCellDef="let element" class="text-center"> {{element.user_upn?element.user_upn:"NA"}} </td>
          </ng-container>

          <ng-container matColumnDef="createdAt"  >
            <th mat-header-cell *matHeaderCellDef > Created Date </th>
            <td mat-cell *matCellDef="let element" class="text-center"> {{element.createdAt}} </td>
          </ng-container>

          <!-- <ng-container matColumnDef="lastLogin">
            <th mat-header-cell *matHeaderCellDef> Last Login </th>
            <td mat-cell *matCellDef="let element"> {{element.last_login_date}} </td>
          </ng-container> -->

          <!-- <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef> Status </th>
            <td mat-cell *matCellDef="let element" class="text-center"> {{element.is_active==1 ? "Enabled" : "Disabled"}} </td>
          </ng-container> -->

          <ng-container matColumnDef="role">
            <th mat-header-cell *matHeaderCellDef> Role </th>
            <td mat-cell *matCellDef="let element" class="text-center"> {{element.user_role}} </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> <i class="fa fa-cogs fa-2x" ></i></th>
            <td mat-cell *matCellDef="let element">
              <div >
                <button mat-raised-button  color="primary"  class="dropdown-toggle m-1"
                 type="button" id="dropdownMenuButton" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false">
                  Actions
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <button mat-stroked-button color="primary" class="dropdown-item"
                   (click)="sendUserToChildComponent_update(element)">
                  <!-- <button mat-stroked-button color="primary" class="dropdown-item"
                   (click)="sendUserToChildComponent(element)" [routerLink]="[element.id,'edit']"> -->
                   Update
                  </button>
                  <!-- <button mat-stroked-button color="primary" class="dropdown-item"
                  (click)="sendUserToChildComponent_resetPassword(element)">
                   Reset Password
                  </button> -->
                  <button mat-stroked-button color="primary" class="dropdown-item"
                  (click)="loadLMSelector(element.id)">
                   Edit Folder access
                  </button>
                  <button mat-stroked-button color="warn"
                  class="dropdown-item" (click)="openDialog(element.id)">Delete</button>
                  <!-- <button mat-stroked-button color="warn" [disabled]="element.user_role=='admin'"
                  class="dropdown-item" (click)="openDialog(element.id)">Delete</button> -->
                </div>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" ></tr>
        </table>
        <!-- [ng-style]="{'background-color':user.is_active ==1 ?  'white': 'lightpink'}" -->

      </div>
      <div *ngIf="users.length==0 && !fetchingData">
        <p>No data available</p>
        <div class="example-button-row">
          <button class="m-1" mat-raised-button style="background-color: blue;color: white;"
          (click)="this.getData()">Refetch data</button>
          <button class="m-1" mat-raised-button style="background-color: green;color: white;"
          [routerLink]="['new']">Insert new user</button>
        </div>
      </div>
    </div>
    <div class="col-md-4" *ngIf="!fetchingData">
      <h2 class="text-capitalize font-weight-bold "><i class="fa fa-address-card text-danger mr-1"></i>Choose<span class="text-lowercase"> a user to update or insert new user</span></h2>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>





<!-- <button class="m-1" mat-raised-button style="background-color: green;color: white;"
(click)="openDialog2()">Open search dialog</button> -->

